<script>
import '@/components/BlurOnLeave'

export default {
	name: 'HeadedView'
}
</script>
<template>

<div class="headed-view">

	<div class="header">
		<img class="logo"
			src="../assets/logo.png"
		/>
		<div class="title">
			<span>Emmanuel</span> Da Silva
		</div>
		<div class="menu">
			<router-link class="bubble" to="/" v-blur-on-leave>Les Sculptures</router-link>
			<router-link class="bubble" to="/contact" v-blur-on-leave>Le Sculpteur</router-link>
		</div>
	</div>

	<transition name="fade">
		<router-view />
	</transition>

</div>

</template>
<style scoped>

.header {
	padding: 1.5em 0;
}

.header {
	display: flex;
	align-items: center;
}
.title {
	white-space: nowrap;
	margin-left: .2em;
	margin-top: -.1em;
}
.menu {
	margin-left: auto;
	text-align: right;
}
.menu a {
	margin-left: 1em;
	padding: .2em .5em;
	border-radius: 3px;
}

/*** Theme ***/

.header {
	color: #FFF;
	font: var(--app-font-header);
	font-size: 120%;
}

.title {
	font: var(--app-font-header);
	font-size: 280%;
	font-weight: 700;
	line-height: .64em;
	text-transform: lowercase;
	transform: scaleY(.8);
}
.title span {
	display: block;
	font-size: 73%;
	font-weight: 400;
	opacity: .8;
}

.menu {
	font-size: 150%;
	font-weight: 100;

}
.menu a.bubble {
	--bubble-color: #CCC;
}
.menu a.router-link-exact-active {
	color:#ff7f00;
}

@media screen and (max-width: 425px) {
	.logo {
		margin-left: 1em;
	}
}

</style>
